/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/#create-a-custom-operator)
 */
var GridLogicOperator;
(function (GridLogicOperator) {
  GridLogicOperator["And"] = "and";
  GridLogicOperator["Or"] = "or";
})(GridLogicOperator || (GridLogicOperator = {}));
export { GridLogicOperator };